import { IPayloadAction } from 'store/type';
import { IUsersState, IUser, IUserScore, IScoreType } from './types';

export function setUser(
    state: IUsersState,
    action: IPayloadAction<IUser>
): IUsersState {
    return {
        ...state,
        user: action.payload,
    };
}

export function setUserScores(
    state: IUsersState,
    action: IPayloadAction<IUserScore[]>
): IUsersState {
    return {
        ...state,
        userScores: action.payload,
    };
}

export function setSessionUserScores(
    state: IUsersState,
    action: IPayloadAction<IUserScore[]>
): IUsersState {
    return {
        ...state,
        sessionUserScores: action.payload,
    };
}

export function setUsers(
    state: IUsersState,
    action: IPayloadAction<IUser[]>
): IUsersState {
    return {
        ...state,
        users: action.payload,
    };
}

export function setScoreTypes(
    state: IUsersState,
    action: IPayloadAction<IScoreType[]>
): IUsersState {
    return {
        ...state,
        scoreTypes: action.payload,
    };
}
